<template>
  <div v-style="{ bg: backgroundColor, py: paddingsMapping }">
    <div :class="{ container: !isFullWidth }">
      <lazy-cms-video-cloudinary-player
        v-if="$feature.enableCloudinaryVideoPlayer && !youtubeId"
        v-bind="{ ...cloudinarySource, ...content.playerSettings }"
      />
      <component
        :is="youtubeId ? BaseYoutube : BaseVideo"
        v-else
        v-bind="video"
        :id="youtubeId"
        :autoplay
        captions
        class="w-full"
        :class="{ 'aspect-video': youtubeId }"
        :controls="!hideControls"
        :loop
        :muted
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { VideoPlayerContent } from '#types/components/cms/video-player'
import { BaseVideo, BaseYoutube } from '#components'

const { content } = defineProps<{
  content: VideoPlayerContent
}>()

const {
  backgroundColor,
  isFullWidth,
  media,
  paddings,
  playerSettings: { autoplay, hideControls, loop, muted } = {},
} = content

const { $viewport, $feature } = useNuxtApp()
const { getMedia } = useCms()
const { ds, components: { cms } } = useAppConfig()
const { componentSpacingMap } = cms.section
const { breakpoints } = ds

const getYoutubeId = (url: string): string | undefined => {
  const regex = /(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))(?<id>[^?&"'>]+)/
  return url.match(regex)?.groups?.id
}

const cloudinarySource = ref()

const source = media && (media.lg || media.md || media.sm)
const youtubeId = source && getYoutubeId(source?.url)

const video = youtubeId ? null : getMedia(media).video

const paddingsMapping = Object.keys(breakpoints).reduce((acc, bp) => ({
  ...acc,
  [bp]: componentSpacingMap[paddings?.[bp]]
}), {})

onMounted(() => {
  if ($feature.enableCloudinaryVideoPlayer) {
    cloudinarySource.value = media?.[$viewport.breakpoint] || media?.sm || media?.md || media?.lg
  }
})
</script>
